import React from 'react';
import PropTypes from 'prop-types';

import { useField } from 'react-final-form';

import { FormRequired } from '/components/forms/components';

import '/components/forms/components/checkbox/checkbox.scss';

const Checkbox = ({ name, value, label, required }) => {
    const { input } = useField(name, {
        value,
        type: 'checkbox',
    });

    return (
        <label className="checkbox">
            <input className="checkbox__input" {...input} />
            <span className="checkbox__icon" />
            <span className="checkbox__label">
                {label}
                <FormRequired required={required} />
            </span>
        </label>
    );
};

Checkbox.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    label: PropTypes.string.isRequired,
    required: PropTypes.bool,
};

Checkbox.defaultProps = {
    value: undefined,
    required: false,
};

export { Checkbox };
